module.exports = __webpack_public_path__ + "static/img/friends.a00738a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loyalty/friends.png
// module id = zdyr
// module chunks = 18